import { render, staticRenderFns } from "./LastComments.vue?vue&type=template&id=f13d387e&scoped=true&"
import script from "./LastComments.vue?vue&type=script&lang=js&"
export * from "./LastComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13d387e",
  null
  
)

export default component.exports